import { render, staticRenderFns } from "./base-input-number-increment.vue?vue&type=template&id=4e573502&scoped=true"
import script from "./base-input-number-increment.vue?vue&type=script&lang=js"
export * from "./base-input-number-increment.vue?vue&type=script&lang=js"
import style0 from "./base-input-number-increment.vue?vue&type=style&index=0&id=4e573502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e573502",
  null
  
)

export default component.exports